











































































































































import Vue, { PropType } from "vue";
import LocalePrice from "@/lib/localePrice";
import Locale from "@/lib/locale";
import VcPlanOptionCreditCardIconFor2devOffer from "@/components/PlanOptionDetail/PlanOptionCreditCardIconFor2devOffer.vue";
import VcPlanOptionStoreAndBankIconFor2devOffer from "@/components/PlanOptionDetail/PlanOptionStoreAndBankIconFor2devOffer.vue";

export interface PlanOptionDetailProps {
  lang: any;
  paymentLang: any;
  link: string;
  target: string;
  price: string;
  defaultCurrency: string;
  buttonMoreDetails: string;
  isShowPlanList: boolean;
  planListLink: string;
  planListText: string;
  payWithPaypalLink: string;
  payWithPaypalText: string;
  isIce: boolean;
  planKey: string;
  detailReplaceLink: any;
  isInitialShowDetail: boolean;
}
export interface PlanOptionDetailData {
  showDetail: boolean;
  priceText: string;
  locale: string;
}

export default Vue.extend({
  name: "vc-plan-option-detail-monthly-ex-2dev-offer",
  components: {
    VcPlanOptionStoreAndBankIconFor2devOffer,
    VcPlanOptionCreditCardIconFor2devOffer
  },
  data(): PlanOptionDetailData {
    return {
      showDetail: false,
      priceText: this.lang.note_price,
      locale: Locale.getLocale()
    };
  },
  props: {
    lang: {
      type: Object as PropType<PlanOptionDetailProps["lang"]>,
      default: () => ({})
    },
    paymentLang: {
      type: Object as PropType<PlanOptionDetailProps["paymentLang"]>,
      default: () => ({})
    },
    link: {
      type: String as PropType<PlanOptionDetailProps["link"]>,
      default: ""
    },
    target: {
      type: String as PropType<PlanOptionDetailProps["target"]>,
      default: ""
    },
    price: {
      type: String as PropType<PlanOptionDetailProps["price"]>,
      default: ""
    },
    defaultCurrency: {
      type: String as PropType<PlanOptionDetailProps["defaultCurrency"]>,
      default: ""
    },
    buttonMoreDetails: {
      type: String as PropType<PlanOptionDetailProps["buttonMoreDetails"]>,
      default: ""
    },

    isShowPlanList: {
      type: Boolean as PropType<PlanOptionDetailProps["isShowPlanList"]>,
      default: false
    },
    planListLink: {
      type: String as PropType<PlanOptionDetailProps["planListLink"]>,
      default: ""
    },
    planListText: {
      type: String as PropType<PlanOptionDetailProps["planListText"]>,
      default: ""
    },
    payWithPaypalLink: {
      type: String as PropType<PlanOptionDetailProps["payWithPaypalLink"]>,
      default: ""
    },
    payWithPaypalText: {
      type: String as PropType<PlanOptionDetailProps["payWithPaypalText"]>,
      default: ""
    },
    isIce: {
      type: Boolean as PropType<PlanOptionDetailProps["isIce"]>,
      default: false
    },
    planKey: {
      type: String as PropType<PlanOptionDetailProps["planKey"]>,
      default: ""
    },
    detailReplaceLink: {
      type: Object as PropType<PlanOptionDetailProps["detailReplaceLink"]>,
      default: () => ({})
    },
    isInitialShowDetail: {
      type: Boolean as PropType<PlanOptionDetailProps["isInitialShowDetail"]>,
      default: false
    }
  },
  computed: {
    isUpdatepass(): boolean {
      return (
        this.planKey === "pro_updatepass" || this.planKey === "ex_updatepass"
      );
    },
    isPayableWithPaypal(): boolean {
      // 日本以外、かつ、アップデートプランの場合は PayPal で支払い可能
      // TODO: 2024-02-01 リリース時点では英仏西独韓繁のみ。次回リリース時に泰尼葡も有効化すること。
      // return this.locale !== "ja-jp" && this.isUpdatepass;
      return (
        [
          "en-us",
          "fr-fr",
          "es-es",
          "de-de",
          "ko-kr",
          "zh-tw",
          "zh-cn"
        ].includes(this.locale) && this.isUpdatepass
      );
    }
  },
  mounted() {
    this.priceText = this.lang.note_price.replace(
      ":price",
      LocalePrice.getPrice(this.locale, Number(this.price))
    );

    // 初期表示で詳細を開いた状態にする設定の場合、詳細を開く
    if (this.isInitialShowDetail) {
      this.changeShowDetail();
    }
  },
  methods: {
    async changeShowDetail() {
      this.showDetail = true;
    }
  }
});
